<template>
  <section class="team" id="team">

    <aside class="team__link">
      <a href="#" @click.prevent="showModal()">More about</a>
    </aside>

    <section-background clazz="background__team"/>
    <h2 class="team__title text-right">Our team</h2>

    <carousel
      :per-page-custom="[[0, 1], [960, 2], [1260, 4]]"
      :mouse-drag="true"
      pagination-active-color="#ebe546"
    >
      <slide>
        <div class="slide-content">



          <img src="../assets/team-1.png" alt="Person face image">
          <div class="team__content">
            <p class="team__name">
              Jan Hrubý
            </p>
            <p class="team__job">
              Founder of vitrix software, software engineer
            </p>
            <p class="team__fun-job">
              chief executive officer of the globe
            </p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-content">
          <img src="../assets/team-2.png" alt="Person face image">
          <div class="team__content">
            <p class="team__name">
              Radek Hlaváček
            </p>
            <p class="team__job">
              Full-stack Developer
            </p>
            <p class="team__fun-job">
              Skilled in car dismantling and punk coding
            </p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-content">
          <img src="../assets/team-3.png" alt="Person face image">
          <div class="team__content">
            <p class="team__name" >
              Tomáš Nosek
            </p>
            <p class="team__job">
              Full-stack developer
            </p>
            <p class="team__fun-job">
              senior office hater
            </p>
          </div>
        </div>
      </slide>
      <slide>
        <div class="slide-content">



          <img src="../assets/team-4.png" alt="Person face image">
          <div class="team__content">

            <p class="team__name">
              Jakub Truneček
            </p>
            <p class="team__job">
              Full-stack developer
            </p>
            <p class="team__fun-job">
              office sender
            </p>
          </div>
        </div>
      </slide>
    </carousel>

    <div class="v-modal" :class="{'v-modal--visible': modal}">

      <div class="container">
        <div class="row d-flex flex-column">
          <div class="col-12">
            <button class="v-modal__button" @click.prevent="showModal()">&times;</button>
          </div>
          <div class="col-12 v-modal__content">
            <p class="v-modal__text">
              We are team of skilled developers working with solid technologies like C++, .NET, HTML5 and Node.js.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import {Carousel, Slide} from 'vue-carousel'
  import SectionBackground from './background'

  export default {
    name: 'Team-area',
    data() {
      return {
        modal: false
      }
    },
    components: {
      Carousel,
      Slide,
      SectionBackground
    },
    methods: {
      showModal() {
        this.modal = !this.modal;

      }
    }
  }
</script>

<style lang="scss">

  @import "../styles/custom";

  .team {
    min-height: 100vh;
    padding: 150px 0;
    position: relative;

    &__title{
      text-transform: uppercase;
      color: #fff;
      text-align: right;
      margin-bottom: 1.5rem;
      padding: 0 150px;
      font-size: 86px;
    }

    &__link {
      position: absolute;
      z-index: 20;
      top: 50%;
      left: 0;
      transform: rotate(90deg) translateX(-25%) translateY(175%);

      @include mobile {
        position: relative;
        transform: rotate(0) translateX(0) translateY(0);
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
      }

      a {
        text-transform: uppercase;
        font-size: 32px;
        line-height: 32px;
        color: #fff;
        text-decoration: none;
        position: relative;
        transition: .2s ease;

        &::after {
          content: '';
          position: absolute;
          bottom: 4px;
          left: 100%;
          width: 64px;
          height: 3px;
          background-color: #fff;
          transition: .2s ease;
          transform: translateY(-50%);
        }
      }

      &:hover a {
        color: $yellow;
        &::after {
          background-color: $yellow;
        }
      }
    }

    &__name {
      color: $yellow;
      text-align: center;
      margin-top: 16px;
      font-size: 32px;
      text-transform: uppercase;
      font-family: Roboto, sans-serif;
    }

    &__job {
      color: #fff;
      font-size: 26px;
      text-align: center;
    }

    &__fun-job {
      color: #fff;
      font-size: 18px;
      text-align: center;
    }
  }

  .VueCarousel {
    max-width: 1400px;
    margin: 0 auto;
    overflow: hidden;

    &-slide {
      padding: 0 16px;

      .slide-content {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;

        img {
          max-width: 300px;
          max-height: 450px;
        }
      }
    }
  }

  .v-modal {

    position: fixed;
    top: 0;
    z-index: 2090;
    right: 100%;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.75);

    .container {
      height: 100%;
    }

    &--visible {
      right: 0;
    }

    &__content {
      flex: 1 0 auto;
      display: flex;
      align-items: center;
    }

    &__button {
      font-size: 64px;
      color: #fff;
      float: right;
      background-color: transparent;
      border: 0;
      margin: 2rem;

      &:hover {
        cursor: pointer;
        color: $yellow;
        outline: 0;
      }

      &:focus {
        outline: 0;
      }
    }

    &__text {
      padding-top: 15vh;
      font-size: 48px;
      color: #fff;
      max-width: 50vw;

      @include mobile {
        padding-top: 1rem;
        font-size: 24px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/TeamArea.vue